export const login = (password) => {
  if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
    localStorage.setItem('auth', 'true');
    return true;
  }
  return false;
};

export const logout = () => {
  localStorage.removeItem('auth');
};

export const isAuthenticated = () => {
  return localStorage.getItem('auth') === 'true';
};

